import "./swipe-action.css";
import { SwipeAction } from './swipe-action';
export default SwipeAction;